import { createContext } from "react";

// { status: "loading" | "ready" | "error", lists, retry }
// See TenantDocumentListsState.js
const TenantDocumentListsContext = createContext(null);

export default TenantDocumentListsContext;
